import { Pipe, PipeTransform } from '@angular/core';
import { UtilService } from 'src/app/core';

@Pipe({
  name: 'getShortName'
})
export class GetShortNamePipe implements PipeTransform {
  transform(name: string): string {
    return UtilService.getAbbreviationName(name);
  }
}
